import { Navigate, useRoutes } from "react-router-dom";
import { getPanelDefaultRoute, getRoutes } from "./routes";

import BlankLayout from "@layouts/types/blank-layout";
import Error from "@src/views/pages/misc/error";
import NotAuthorized from "@src/views/pages/misc/not-authorized";
import { getItemFromStore } from "../utility/helpers/utils";
import { useMemo } from "react";

const Router = () => {
  // getRoutes() mutates route.element on the shared route objects (wrapping them
  // in layout/guard components) — calling it on every render re-wraps an already
  // wrapped element, which changes the element type at that tree position and
  // forces React to unmount/remount the matched page (double-firing its data
  // fetches). Memoizing so it runs exactly once for the app's lifetime avoids that.
  const allRoutes = useMemo(() => getRoutes(), []);

  const getHomeRoute = () => {
    if (!getItemFromStore("token")) {
      return "/login";
    } else {
      return getPanelDefaultRoute();
    }
  };
  // Use the getHomeRoute() function to get the destination route
  const destinationRoute = getHomeRoute();
  const routes = useRoutes([
    {
      path   : "/",
      index  : true,
      element: <Navigate replace to={destinationRoute} />
    },
    {
      path    : "/misc/not-authorized",
      element : <BlankLayout />,
      children: [
        {
          path   : "/misc/not-authorized",
          element: <NotAuthorized />,
          meta   : {
            publicRoute: true,
            layout     : "blank"
          }
        }
      ]
    },
    {
      path    : "*",
      element : <BlankLayout />,
      children: [{ path: "*", element: <Error /> }]
    },

    ...allRoutes
  ]);

  return routes;
};

export default Router;
